export class RepDeactivation {

  cancelDate!: Date;
  newRepId!: string;

}
